import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { BroadcastMessageRoutingModule } from './broadcast-message-route.module';
import { ToastModule } from 'primeng/toast';
import { TranslateModule } from '@ngx-translate/core';
import { BroadcastMessageComponent } from './broadcast-message.component';
import { SliderModule } from 'primeng/slider';
import { SharedModule } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { MultiSelectModule } from 'primeng/multiselect';
import { RadioButtonModule } from 'primeng/radiobutton';
import { TableModule } from 'primeng/table';
import { CoreModule } from '../core';
import { CalendarModule } from 'primeng/calendar';
import { InputTextModule } from 'primeng/inputtext';


@NgModule({
  imports: [
    CommonModule,
    BroadcastMessageRoutingModule,
    TableModule,
    CoreModule,
    FormsModule,
    TranslateModule,
    RadioButtonModule,
    ButtonModule,
    ToastModule, SliderModule,
    CalendarModule,
    SharedModule,
    MultiSelectModule, InputTextModule,
  ],
  declarations: [BroadcastMessageComponent]
})
export class BroadcastMessageModule { }
